const isValidDate = (date) => date instanceof Date && !Number.isNaN(date.getTime());

const normalizeEpochInput = (value) => {
  const trimmed = value?.toString().trim();
  if (!trimmed) {
    throw new Error('Informe um valor epoch (segundos ou milissegundos).');
  }

  const numericValue = Number(trimmed);
  if (!Number.isFinite(numericValue)) {
    throw new Error('Epoch inválido: use apenas números.');
  }

  if (numericValue < 0) {
    throw new Error('Epoch não pode ser negativo.');
  }

  return numericValue;
};

const toDateFromEpoch = (epoch) => {
  const milliseconds = epoch > 1e12 ? epoch : epoch * 1000;
  const date = new Date(milliseconds);
  if (!isValidDate(date)) {
    throw new Error('Não foi possível converter o epoch informado.');
  }

  return { date, milliseconds };
};

export const convertEpochToHumanReadable = (value) => {
  const epoch = normalizeEpochInput(value);
  const { date, milliseconds } = toDateFromEpoch(epoch);

  const seconds = Math.floor(milliseconds / 1000);
  const isoString = date.toISOString();
  const localeString = date.toLocaleString('pt-BR', { hour12: false });

  return [
    `ISO: ${isoString}`,
    `Local (pt-BR): ${localeString}`,
    `UTC: ${date.toUTCString()}`,
    `Epoch (segundos): ${seconds}`,
    `Epoch (milissegundos): ${milliseconds}`,
  ].join('\n');
};

export const convertHumanReadableToEpoch = (dateValue) => {
  const raw = dateValue?.toString().trim();
  if (!raw) {
    throw new Error('Informe uma data para converter.');
  }

  const date = new Date(raw);
  if (!isValidDate(date)) {
    throw new Error('Data inválida. Utilize um formato aceito pelo JavaScript (ex: 2024-08-31T15:00).');
  }

  const milliseconds = date.getTime();
  const seconds = Math.floor(milliseconds / 1000);

  return [
    `Data (ISO): ${date.toISOString()}`,
    `Epoch (segundos): ${seconds}`,
    `Epoch (milissegundos): ${milliseconds}`,
  ].join('\n');
};

const converters = {
  convertEpochToHumanReadable,
  convertHumanReadableToEpoch,
};

export default converters;
